import type { ReactNode } from 'react';

/** Eén regel in het contactblok van een dossier: label links, waarde rechts. */
export function ContactRow({
  label,
  children
}: {
  label: string;
  children: ReactNode;
}) {
  return <div className="grid grid-cols-[6.5rem_1fr] gap-3" data-id="element-1063" data-mp="3utiwy32apgwi">
      <dt className="text-muted" data-id="element-1064" data-mp="3uw5caovfh0pa">{label}</dt>
      <dd className="min-w-0 text-ink" data-id="element-1065" data-mp="2qhyjgfm4hwm">{children}</dd>
    </div>;
}